import React from 'react';
import { fireBoardCreateErrorAnalytics } from '../common/utils.tsx';
import { BoardCreateFlyoutMenu } from './flyout-menu/index.tsx';
import type { BoardCreateProps } from './types.tsx';

export const BoardCreate = ({
	projectId,
	projectAvatar,
	renderTrigger,
	triggerRef,
}: BoardCreateProps) => {
	if (!projectId) {
		fireBoardCreateErrorAnalytics({
			error: new Error(
				'Failed to load board create flyout menu: projectId undefined',
			),
			attributes: {
				projectId,
			},
			id: 'loadFlyoutMenu',
		});

		return null;
	}

	return (
		<BoardCreateFlyoutMenu
			renderTrigger={renderTrigger}
			projectId={projectId}
			projectAvatar={projectAvatar}
			triggerRef={triggerRef}
		/>
	);
};
